import { createReducer } from 'typesafe-actions';

import { toggleFeedbackDrawer } from './actions';
import type { FeedbackAction, FeedbackState } from './types';

export const initialFeedbackState: FeedbackState = {
  feedbackDrawerVisible: false,
};

export const feedbackReducer = createReducer<FeedbackState, FeedbackAction>(
  initialFeedbackState
).handleAction(toggleFeedbackDrawer, (state) => {
  return {
    ...state,
    feedbackDrawerVisible: !state.feedbackDrawerVisible,
  };
});
